import {
  getCadFckBrSls, postCadFckBrSl, putCadFckBrSl, exportCadFckBrSls, importCadFckBrSls,
} from '../../../Api/services/backoffice';

export const key = 'cadFckBrSl';

const entityName = {
  singular: 'Cad. FCK BR SL',
  plural: 'FCK Brita Slump',
};

const queries = {
  list: { key, fn: getCadFckBrSls },
  detail: { key },
};

const mutations = {
  create: postCadFckBrSl,
  update: putCadFckBrSl,
};

const fields = {
  table: [
    { key: 'trait.name', label: 'Traço' },
    { key: 'trait.traitFamily.name', label: 'Família' },
    { key: 'Fck', label: 'FCK' },
    { key: 'br', label: 'Brita' },
    { key: 'sl', label: 'Slump' },
  ],
};

export const listConfig = {
  title: entityName.plural,
  tableFields: fields.table,
  searchFields: fields.search,
  queryConfig: queries.list,
  showBatchButton: true,
};

export const createConfig = {
  entityName: entityName.singular,
  mutationFn: mutations.create,
};

export const updateConfig = {
  entityName: entityName.singular,
  mutationFn: mutations.update,
  queryConfig: queries.detail,
};

export const batchConfig = {
  entityName: entityName.plural,
  exportFn: exportCadFckBrSls,
  importFn: importCadFckBrSls,
};
